import script from "./LeftBarAdvertisement.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftBarAdvertisement.vue?vue&type=script&setup=true&lang=js"

import "./LeftBarAdvertisement.vue?vue&type=style&index=0&id=003b877e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-003b877e"]])

export default __exports__